export enum ILanguage {
  en = 1,
  // https://zh.wikipedia.org/zh-hans/ISO_3166-1%E4%BA%8C%E4%BD%8D%E5%AD%97%E6%AF%8D%E4%BB%A3%E7%A0%81
  de = 2,
  es = 3,
  fr = 4,
  it = 5,
  id = 6,
  pl = 7,
  pt = 8,
  ru = 9,
}

export const I18N: Record<ILanguage, string> = {
  [ILanguage.en]: '', // 英文不需要加前缀 /en，避免重复页面
  [ILanguage.de]: 'de',
  [ILanguage.es]: 'es',
  [ILanguage.fr]: 'fr',
  [ILanguage.it]: 'it',
  [ILanguage.id]: 'id',
  [ILanguage.pl]: 'pl',
  [ILanguage.pt]: 'pt',
  [ILanguage.ru]: 'ru',
};

export const I18NStringToId: Record<string, ILanguage> = {
  en: ILanguage.en,
  de: ILanguage.de,
  es: ILanguage.es,
  fr: ILanguage.fr,
  it: ILanguage.it,
  id: ILanguage.id,
  pl: ILanguage.pl,
  pt: ILanguage.pt,
  ru: ILanguage.ru,
};

export const I18N_LIST = Object.values(I18N);
export const localeLanguageNameMap: Record<string, string> = {
  en: 'English',
  de: 'Deutsch',
  es: 'Español',
  fr: 'Français',
  it: 'Italiano',
  id: 'Indonesia',
  pl: 'Polski',
  pt: 'Português',
  ru: 'Русский',
};
